import { useQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { UNBATCHED_CONTEXT, getPreloadQuery } from "@/shared/gql/apollo-client";
import type { SourcingReviewSearch } from "@/pages/admin-sourcing-review/model/search-params";

const FetchSourcingReviewQueue = graphql(`
  query FetchSourcingReviewQueue($input: SearchSourcingReviewQueueInput!) {
    superAdmin {
      sourcingReviewQueue(input: $input) {
        paginatorInfo {
          total
        }
        data {
          issue
          bucket
          hint
          lastScanAt
          website {
            id
            name
            url
            organisation {
              id
              name
            }
          }
        }
      }
    }
  }
`);

const FetchSourcingReviewQueueSummary = graphql(`
  query FetchSourcingReviewQueueSummary {
    superAdmin {
      sourcingReviewQueueSummary {
        issue
        bucket
        count
      }
    }
  }
`);

export const SOURCING_REVIEW_QUEUE_PAGE_SIZE = 50;

export const toSourcingReviewQueueInput = (search: SourcingReviewSearch) => ({
  bucket: search.bucket,
  issue: search.issue,
  paginator: {
    page: search.page ?? 1,
    take: SOURCING_REVIEW_QUEUE_PAGE_SIZE,
  },
});

export const useFetchSourcingReviewQueue = (search: SourcingReviewSearch) =>
  useQuery(FetchSourcingReviewQueue, {
    variables: { input: toSourcingReviewQueueInput(search) },
  });

export const useFetchSourcingReviewQueueSummary = () =>
  useQuery(FetchSourcingReviewQueueSummary, {
    context: UNBATCHED_CONTEXT,
  });

export const preloadSourcingReviewQueue = (search: SourcingReviewSearch) => {
  getPreloadQuery()(FetchSourcingReviewQueue, {
    variables: { input: toSourcingReviewQueueInput(search) },
  });
  getPreloadQuery()(FetchSourcingReviewQueueSummary, {
    context: UNBATCHED_CONTEXT,
  });
};
